/* eslint-disable no-unused-vars */
import { post } from "jquery";
import { Delete, Get, Post, PostFormData, Put, PutFormData } from "../Request";

export default {
  state: {
    Downloadfiles: [],
    DownloadfileGroups: [],
  },
  getters: {
    GetDownloadFiles(state) {
      return state.Downloadfiles;
    },
    GetDownloadFileGroups(state) {
      return state.DownloadfileGroups;
    },
  },
  actions: {
    async EditDownloadFileGroups({ commit }, payload) {
      return await Put("Download/UpdateDownloadFileGroup", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async ToggleFileVisibility({ commit }, payload) {
      return await Put(
        `Download/ToggleFileVisibility/${payload}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteDownloadFileGroups({ commit }, payload) {
      return await Delete(
        `Download/DeleteDownloadFileGroup/${payload}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteDownloadFile({ commit }, payload) {
      return await Delete(
        `Download/DeleteDownloadFile/${payload}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async SortDownloadFileGroup({ commit }, payload) {
      return await Post(`Download/SortDownloadFileGroup?sortNum=${payload.sortNum}&Id=${payload.Id}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async GetDownloadfiles({ commit }, payload) {
      return await Get(
        `Download/GetDownloadFile?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.categories}`
      ).then((res) => {
        commit("SetDownloadfiles", res.data.Data.List);

        return res.data;
      });
    },
    async GetDownloadFileGroups({ commit }, payload) {
      return await Get("Download/GetDownloadFileGroup").then((res) => {
        commit("SetDownloadfileGroups", res.data.Data);

        return res.data;
      });
    },
    async DownloadFile({ commit }, payload) {
      return await Get(`Download/DownloadFile/${payload}`).then((res) => {
        return res.data;
      });
    },
    async CreateDownloadFile({ commit }, payload) {
      return await PostFormData("Download/CreateDownloadFile", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async UpdateDownloadFile({ commit }, payload) {
      return await PutFormData("Download/UpdateDownloadFile", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async CreateDownloadFileGroup({ commit }, payload) {
      return await PostFormData(
        "Download/CreateDownloadFileGroup",
        payload
      ).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetDownloadfiles(state, payload) {
      state.Downloadfiles = payload;
    },
    SetDownloadfileGroups(state, payload) {
      state.DownloadfileGroups = payload;
    },
  },
};
